module.exports = __webpack_public_path__ + "img/1080_14.fb8573e6.jpg";